// Достижения: 20 наград за игровые события. Всё локально (localStorage) —
// сервер не нужен, а прогресс переживает сессии. Проверки — по событиям
// из game.mjs, суммарные счётчики копятся здесь же.

const STORE_KEY = 'etazhi_tower_achievements';

// check(data, stats) → true = получено. stats — накопленные счётчики.
const DEFS = [
  { id: 'first_floor',   icon: '🧱', title: 'Первый этаж',        desc: 'Поставь свой первый блок',                 ev: 'floor',  check: () => true },
  { id: 'first_perfect', icon: '🎯', title: 'В яблочко',          desc: 'Первая посадка PERFECT',                   ev: 'perfect', check: () => true },
  { id: 'first_win',     icon: '🏠', title: 'Сдан в срок',        desc: 'Сдай своё первое здание',                  ev: 'win',    check: () => true },
  { id: 'combo_5',       icon: '🔥', title: 'Серия из пяти',      desc: 'Собери комбо ×5',                          ev: 'perfect', check: (d) => d.combo >= 5 },
  { id: 'combo_10',      icon: '🚁', title: 'Вертолётная высота', desc: 'Собери комбо ×10 — прилетит вертолёт',     ev: 'perfect', check: (d) => d.combo >= 10 },
  { id: 'golden_first',  icon: '🪙', title: 'Золотые руки',       desc: 'Посади первый золотой блок',               ev: 'golden', check: () => true },
  { id: 'golden_10',     icon: '💰', title: 'Золотой фонд',       desc: '10 золотых блоков за всё время',           ev: 'golden', check: (d, s) => s.golden >= 10 },
  { id: 'clean_win',     icon: '✨', title: 'Идеальная сдача',    desc: 'Построй здание из одних перфектов',        ev: 'win',    check: (d) => d.perfects >= d.floors },
  { id: 'no_lives_lost', icon: '🛡️', title: 'Без единой трещины', desc: 'Победа, не потеряв ни одной жизни',        ev: 'win',    check: (d) => d.livesLost === 0 },
  { id: 'comeback',      icon: '💪', title: 'На последнем блоке', desc: 'Победа с одной оставшейся жизнью',         ev: 'win',    check: (d) => d.livesLeft === 1 },
  { id: 'record_beat',   icon: '📈', title: 'Выше себя',          desc: 'Побей свой рекорд высоты',                 ev: 'record', check: () => true },
  { id: 'level_5',       icon: '🌆', title: 'Полпути к небу',     desc: 'Открой уровень 5 — Башню Федерация',       ev: 'win',    check: (d) => d.levelId >= 4 },
  { id: 'level_10',      icon: '🌃', title: 'Финальная стройка',  desc: 'Открой уровень 10 — Башню Этажей',         ev: 'win',    check: (d) => d.levelId >= 9 },
  { id: 'tower_100',     icon: '🏆', title: 'Строй выше. Живи лучше.', desc: 'Построй 100-этажную Башню Этажей',    ev: 'win',    check: (d) => d.levelId >= 10 },
  { id: 'floors_100',    icon: '🏗️', title: 'Сто этажей опыта',   desc: '100 этажей суммарно за всё время',         ev: 'floor',  check: (d, s) => s.floors >= 100 },
  { id: 'floors_500',    icon: '🌇', title: 'Микрорайон',         desc: '500 этажей суммарно за всё время',         ev: 'floor',  check: (d, s) => s.floors >= 500 },
  { id: 'meters_300',    icon: '🗼', title: 'Эйфелева норма',     desc: '300 метров суммарно — высота Эйфелевой',   ev: 'floor',  check: (d, s) => s.floors * 3 >= 300 },
  { id: 'perfects_50',   icon: '🎖️', title: 'Снайпер стройки',    desc: '50 перфектов за всё время',                ev: 'perfect', check: (d, s) => s.perfects >= 50 },
  { id: 'share_first',   icon: '📣', title: 'Прораб-блогер',      desc: 'Поделись своей башней',                    ev: 'share',  check: () => true },
  { id: 'daily_3',       icon: '📅', title: 'Постоянный клиент',  desc: 'Играй 3 разных дня',                       ev: 'day',    check: (d, s) => Object.keys(s.days || {}).length >= 3 },
];

export function createAchievements({ onUnlock }) {
  let data;
  try {
    data = JSON.parse(localStorage.getItem(STORE_KEY) || '{}');
  } catch (e) { data = {}; }
  data.unlocked = data.unlocked || {};
  data.stats = data.stats || { floors: 0, perfects: 0, golden: 0, days: {} };

  function save() {
    localStorage.setItem(STORE_KEY, JSON.stringify(data));
  }

  // Отметка «играл сегодня» — для достижений за регулярность
  data.stats.days = data.stats.days || {};
  data.stats.days[new Date().toDateString()] = 1;
  // Держим не больше 40 дат, старое неважно
  const days = Object.keys(data.stats.days);
  if (days.length > 40) for (const d of days.slice(0, days.length - 40)) delete data.stats.days[d];
  save();

  function event(name, payload = {}) {
    // Счётчики
    if (name === 'floor') data.stats.floors += 1;
    if (name === 'perfect') data.stats.perfects += 1;
    if (name === 'golden') data.stats.golden += 1;

    let dirty = true; // счётчики уже изменились — сохраняем в любом случае
    for (const def of DEFS) {
      if (def.ev !== name && !(def.ev === 'day' && name === 'floor')) continue;
      if (data.unlocked[def.id]) continue;
      let ok = false;
      try { ok = def.check(payload, data.stats); } catch (e) { ok = false; }
      if (ok) {
        data.unlocked[def.id] = Date.now();
        dirty = true;
        if (onUnlock) onUnlock(def);
      }
    }
    if (dirty) save();
  }

  return {
    event,
    list() {
      return DEFS.map((d) => ({ ...d, unlocked: !!data.unlocked[d.id] }));
    },
    get unlockedCount() { return Object.keys(data.unlocked).length; },
    get total() { return DEFS.length; },
  };
}
